<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentcolor">
    <path
      d="M16.1705 14.9487L16.1776 12.7071H18.1716V18.364H12.5147V16.3699L14.7563 16.3629L4.73657 6.34317L6.15079 4.92896L16.1705 14.9487Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
